import { useEffect, useState } from "react";

export enum Breakpoint {
  XSS = "XSS",
  XS = "XS",
  SM = "SM",
  MD = "MD",
  LG = "LG",
  XL = "XL",
}

const getCurrentBreakpoint = (width: number): Breakpoint => {
  if (width < 420) return Breakpoint.XSS;
  if (width < 768) return Breakpoint.XS;
  if (width < 900) return Breakpoint.SM;
  if (width < 1024) return Breakpoint.MD;
  if (width < 1520) return Breakpoint.LG;
  return Breakpoint.XL;
};

export const useBreakpoint = (): Breakpoint => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() =>
    getCurrentBreakpoint(typeof window !== "undefined" ? window.innerWidth : 1200)
  );

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getCurrentBreakpoint(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return breakpoint;
};
